import _get from 'lodash/get'
import _map from 'lodash/map'

export const addOnsAdapter = (addOns = []) =>
  _map(addOns, el => ({ id: el.id, type: el.type, ..._get(el, 'attributes', {}) }))

export const addOnAdapter = (addOn = {}) => {
  const attributes = _get(addOn, 'attributes', {})
  return { ...addOn, ...attributes }
}